import './Sidebar.scss'
import React from 'react'

export default ({ children }) => (
  <div className="sidebar">
    { children }
  </div>
)
